import React, { FC, useCallback } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import { SummaryEntryRowProps } from '@components/ncFileVersions/components/NCFileDiffView/ChangeSummaryPanel/types';
import {
  CATEGORY_COLOR_TOKEN,
  CATEGORY_DOT_SIZE,
  SUMMARY_ENTRY_TEST_ID_PREFIX,
} from '../../constants/changeSummaryPanel.constants';

const SummaryEntryRow: FC<SummaryEntryRowProps> = ({ C, entry, onJumpToChange }) => {
  const handlePress = useCallback(() => onJumpToChange(entry), [entry, onJumpToChange]);
  const testID = `${SUMMARY_ENTRY_TEST_ID_PREFIX}${entry.id}`;
  const dotColor = C(CATEGORY_COLOR_TOKEN[entry.category]);
  const labelColor = C('Label/Light/Primary');

  return (
    <TouchableElement onPress={handlePress} useOpacity testID={testID}>
      {({ pressHoverColor, boxStyle }) => (
        <View style={[boxStyle, styles.entryRow, { backgroundColor: C(pressHoverColor('Background/Light/Field')) }]}>
          <View style={[styles.dot, { backgroundColor: dotColor }]} />
          <Text style={[font['Subhead 2'], styles.entryLabel, { color: labelColor }]} numberOfLines={1}>
            {entry.label}
          </Text>
        </View>
      )}
    </TouchableElement>
  );
};

const styles = StyleSheet.create({
  entryRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(8),
    paddingHorizontal: scale(8),
    paddingVertical: scale(6),
    borderRadius: scale(8),
  },
  entryLabel: {
    flex: 1,
  },
  dot: {
    width: scale(CATEGORY_DOT_SIZE),
    height: scale(CATEGORY_DOT_SIZE),
    borderRadius: scale(CATEGORY_DOT_SIZE) / 2,
  },
});

export default SummaryEntryRow;
